function closeMiniCart() {
  var miniCart = document.getElementById("mini-cart");
  if (miniCart.hasAttribute("open")) {
    miniCart.removeAttribute("open");
  }
}

$(document).on("click", ".tab-set-unique1 .tab-link", function () {
  var tabId = $(this).data("tab");
  var tabSet = $(this).closest(".tab-set");

  tabSet.find(".tab-link").removeClass("active");
  tabSet.find(".tab-content").hide();
  $(".hidde-burger-slider").hide();
  $(".slider-" + tabId).show();
  $(this).addClass("active");

  $("#" + tabId).fadeIn();
});

// Function to update the variant ID and image
function updateVariantIdAndImage(productForm) {
  const productData = JSON.parse(productForm.dataset.productJson);
  const selectedOptions = [];

  // Collect selected options
  productData.options.forEach((option, index) => {
    const select = productForm.querySelector(`select[name="option-${index}"]`);
    selectedOptions.push(select.value);
  });

  // Find the matching variant
  const matchingVariant = productData.variants.find((variant) => {
    return variant.options.every(
      (option, index) => option === selectedOptions[index]
    );
  });

  // Get elements once
  const productItem = productForm.closest(".product-item");
  const imageElement = productItem.querySelector(".product-image img");
  const addToCartButton = productForm.querySelector(".add-to-cart-button");
  const soldOutBadge = productForm.querySelector(".sold-out-badge");

  if (matchingVariant) {
    productForm.querySelector(".variant-id").value = matchingVariant.id;

    // Update image if available
    if (
      matchingVariant.featured_media &&
      matchingVariant.featured_media.preview_image &&
      matchingVariant.featured_media.preview_image.src
    ) {
      if (
        imageElement.src !== matchingVariant.featured_media.preview_image.src
      ) {
        imageElement.src = matchingVariant.featured_media.preview_image.src;
      }
    }

    // Update button state
    if (matchingVariant.available) {
      addToCartButton.classList.remove("not-available-variant");
      addToCartButton.classList.add("available-variant");
      addToCartButton.disabled = false;
      soldOutBadge.style.display = "none";
    } else {
      addToCartButton.classList.remove("available-variant");
      addToCartButton.classList.add("not-available-variant");
      addToCartButton.disabled = true;
      soldOutBadge.style.display = "inline";
    }
  } else {
    productForm.querySelector(".variant-id").value = "";
    imageElement.src = productData.featured_image.src;

    addToCartButton.classList.remove("available-variant");
    addToCartButton.classList.add("not-available-variant");
    addToCartButton.disabled = true;
    soldOutBadge.style.display = "inline";
  }

  console.log("Variant update completed");
}

// Function to handle onchange event
function myFunction(selectElement) {
  // Find the closest product form from the select element
  const productForm = selectElement.closest(".product-form");

  // Call the update function
  updateVariantIdAndImage(productForm);
}

document.addEventListener("DOMContentLoaded", (event) => {
  setupRatingSnippet();
  setTimeout(function () {
    setupRatingSnippet();
  }, 500); // Delay for 1 second
});

setupRatingSnippet();
document.addEventListener("cart:refresh", function (event) {
  setTimeout(function () {
    setupRatingSnippet();
  }, 300); // Delay for 1 second
});

// Select elements
const versandOpenPopupBtn = document.getElementById("versand-open-popup");
const versandClosePopupBtn = document.getElementById("versand-close-popup");
const versandPopup = document.getElementById("versand-popup");
const versandPopupOverlay = document.getElementById("versand-popup-overlay");
const versandBody = document.body;

// Function to open the popup
function versandOpenPopup() {
  versandPopup.style.display = "block";
  versandPopupOverlay.style.display = "block";
  versandBody.classList.add("versand-no-scroll"); // Disable scrolling on body
}

// Function to close the popup
function versandClosePopup() {
  versandPopup.style.display = "none";
  versandPopupOverlay.style.display = "none";
  versandBody.classList.remove("versand-no-scroll"); // Enable scrolling on body
}

if (versandOpenPopupBtn) {
  versandOpenPopupBtn.addEventListener("click", versandOpenPopup);
}

if (versandClosePopupBtn) {
  versandClosePopupBtn.addEventListener("click", versandClosePopup);
}

if (versandPopupOverlay) {
  versandPopupOverlay.addEventListener("click", versandClosePopup);
}

function checkClassOnSelectedMedia() {
  if ($(".product__media-item.is-selected").hasClass("info-bar-active")) {
    $(".custom-lines-only").removeClass("lines-present");
    $(".custom-arrow-only").removeClass("lines-present-2");
  } else {
    $(".custom-lines-only").addClass("lines-present");
    $(".custom-arrow-only").addClass("lines-present-2");
  }
}

checkClassOnSelectedMedia();

// Overflow-Scroller for CP Swatches
document.addEventListener("DOMContentLoaded", function () {
  // Funktion, um zu überprüfen, ob ein Element überläuft
  function hasOverflow(element) {
    return element.scrollWidth > element.clientWidth;
  }

  const elements = document.querySelectorAll(
    ".product-item-meta__variation-products .inner"
  );

  elements.forEach((element) => {
    if (hasOverflow(element)) {
      element.classList.add("has-overflow");
    }
  });
});

// const sliders = document.querySelectorAll('.product-item-meta__variation-products .inner');

// sliders.forEach(slider => {
//     let isDown = false;
//     let startX;
//     let scrollLeft;

//     slider.addEventListener('mousedown', (e) => {
//         isDown = true;
//         slider.classList.add('active');
//         startX = e.pageX;
//         scrollLeft = slider.scrollLeft;
//     });

//     slider.addEventListener('mouseleave', () => {
//         isDown = false;
//         slider.classList.remove('active');
//     });

//     slider.addEventListener('mouseup', () => {
//         isDown = false;
//         slider.classList.remove('active');
//     });

//     slider.addEventListener('mousemove', (e) => {
//         if (!isDown) return;  // Stop the function from running if not clicked
//         e.preventDefault();
//         const x = e.pageX - startX;
//         slider.scrollLeft = scrollLeft - x * 2;  // Adjust scrolling speed by multiplying
//     });
// });

/* Image Switch on CP */
document
  .querySelectorAll(".product-item .color-relations .variant-swatch__item")
  .forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();

      const productItem = item.closest(".product-item");
      if (!productItem) return;

      productItem
        .querySelectorAll(".variant-swatch__item.active")
        .forEach((activeItem) => {
          activeItem.classList.remove("active");
        });

      item.classList.add("active");

      const primaryImage = productItem.querySelector(
        ".product-item__image-wrapper .product-item__primary-image"
      );
      if (item.getAttribute("data-primary-image") != "none") {
        const newPrimarySrc = item.getAttribute("data-primary-image");
        if (newPrimarySrc) {
          primaryImage.setAttribute("src", newPrimarySrc);
          primaryImage.setAttribute("srcset", newPrimarySrc);
        }
      }
      else {
        const newSecondarySrc = item.getAttribute("data-secondary-image");
        primaryImage.setAttribute("src", newSecondarySrc);
        primaryImage.setAttribute("srcset", newSecondarySrc);
      }

      const secondaryImage = productItem.querySelector(
        ".product-item__image-wrapper .product-item__secondary-image"
      );
      if (secondaryImage) {
        const newSecondarySrc = item.getAttribute("data-secondary-image");
        if (newSecondarySrc) {
          secondaryImage.setAttribute("src", newSecondarySrc);
          secondaryImage.setAttribute("srcset", newSecondarySrc);
        }
      }
      const variantUrl = item.getAttribute("data-variant-url");
      if (variantUrl) {
        const imageWrapperLink = productItem.querySelector(
          ".product-item__image-wrapper a"
        );
        if (imageWrapperLink) {
          imageWrapperLink.setAttribute("href", variantUrl);
        }

        const metaLink = productItem.querySelector(".product-item-meta a");
        if (metaLink) {
          metaLink.setAttribute("href", variantUrl);
        }
      }
    });
  });
